import { FC } from 'react';

import { PartnerType } from '@prisma/client';
import { Formik, FormikProps } from 'formik';

import { useQuery } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { useAuthContext } from 'src/contexts/AuthProvider';
import { GET_ACTIVE_PARTNERS } from 'src/graphql/queries/partners.query';
import { isIreland } from 'src/lib/countryConfig';

import { SelectPartnerFormValues } from '../../types';
import selectPartnerValidation from '../../utils/validation';

import { SelectPartner as SelectPartnerChild } from './components/SelectPartner';

export const SelectPartner: FC = () => {
    const { user } = useAuthContext();
    const { addMerchant, merchantApplication } = useAddMerchantContext();

    const initialValues: SelectPartnerFormValues = {
        partner: merchantApplication?.partnerId?.toString() || user?.partner?.id.toString() || '',
        partnerType: merchantApplication?.partnerType?.toString() || '',
        partnerOfPartner: merchantApplication?.partnerOfPartnerId?.toString() || '',
        country: merchantApplication?.country || (isIreland ? 'Ireland' : ''),
    };

    const { data } = useQuery(GET_ACTIVE_PARTNERS, {
        onError: () => {
            showErrorToast('Error fetching the partners');
        },
        fetchPolicy: 'cache-and-network',
    });

    const handleSubmit = async ({
        partner,
        partnerOfPartner,
        country,
    }: SelectPartnerFormValues) => {
        const partnerType = partnerOfPartner ? PartnerType.PARTNER_OF_PARTNER : PartnerType.PARTNER;

        if (partnerType === PartnerType.PARTNER) {
            await addMerchant({
                partnerId: Number(partner),
                partnerType,
                country,
            });
        } else {
            await addMerchant({
                partnerId: Number(partner),
                partnerOfPartnerId: Number(partnerOfPartner),
                partnerType,
                country,
            });
        }
    };

    return (
        <Formik
            key={`${merchantApplication?.id}-${user?.id}`}
            initialValues={initialValues}
            onSubmit={async ({ partner, partnerOfPartner, country }: SelectPartnerFormValues) => {
                await handleSubmit({ partner, partnerOfPartner, country });
            }}
            validationSchema={selectPartnerValidation}
        >
            {(formikProps: FormikProps<SelectPartnerFormValues>) => {
                return <SelectPartnerChild formikProps={formikProps} data={data} />;
            }}
        </Formik>
    );
};

export default SelectPartner;
